import { getLocale } from "@/lib/localeHelper";
import { setLocale } from "@/modules/i18n";
import loadConfig from "../loadConfig";

export default async function () {
  let error: Error = new Error("default error");

  for (let i = 0; i < 3; i++) {
    try {
      await loadConfig();
      // the app translates at module scope in many places, so messages must be in before it is imported
      await setLocale(getLocale());
      const { createApp } = await import("./");
      return { app: createApp() };
    } catch (e) {
      error = e as Error;
      await new Promise(r => setTimeout(r, 1000));
    }
  }

  const { createErrorApp } = await import("./createError");
  return { app: createErrorApp(error) };
}
